import { Outlet } from "react-router";

import { MSPDashboard as MSPDashboardComponent } from "@components/Dashboards";

export const Dashboard = () => {
  return (
    <>
      <MSPDashboardComponent />
      <Outlet />
    </>
  );
};
